<script setup lang="ts">
import { computed, useSlots } from 'vue'

const props = defineProps<{
  title?: string
}>()

const slots = useSlots()
const hasTitle = computed(() => !!slots.title || !!props.title)

function create_id(label: string) {
  return label.toLowerCase().replace(/ /g, '-')
}
</script>

<template>
  <div
    v-if="hasTitle"
    data-component="VCardTitle"
    class="mb-5 flex items-center justify-between border-b border-[var(--divider-color,#EEEFF0)] pb-1"
  >
    <h3 v-if="title" :id="create_id(title)" class="font-semibold leading-7 text-gray-700">
      <a :href="`#${create_id(title)}`" tabindex="-1">{{ title }}</a>
    </h3>
    <slot name="title" />
    <slot name="actions" />
  </div>
</template>
